// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

import React from "react";
/** @jsx jsx */ import { Global, css, jsx } from "@emotion/core";
import { sizes, expandValue } from "../../helpers/theme";

var tinycolor = require("tinycolor2");

export class ThemeColors extends React.Component {
  render() {
    return (
      <Global
        styles={css`
          html,
          body {
            *::selection {
              background: ${this.props.color2};
            }
            *::-moz-selection {
              background: ${this.props.color2};
            }
          }
          .primary-nav {
            background: ${tinycolor(this.props.bg1)
              .darken(5)
              .setAlpha(0)
              .toRgbString()};
          }
          .primary-nav.Chill {
            background: ${tinycolor(this.props.bg1)
              .darken(5)
              .setAlpha(0.7)
              .toRgbString()};
          }
          .primary-nav .nav-link {
            text-shadow: 0 ${expandValue(sizes.space * 0.125)}
              ${expandValue(sizes.space * 0.5)}
              ${tinycolor(this.props.color)
                .setAlpha(0.4)
                .toString()};
            &:hover {
              color: ${tinycolor(this.props.color2)
                .lighten(10)
                .brighten(10)
                .toString()};
              &:before {
                background: ${tinycolor(this.props.color2)
                  .lighten(10)
                  .brighten(10)
                  .toString()};
                box-shadow: 0 ${expandValue(sizes.space * 0.125)}
                  ${expandValue(sizes.space)}
                  ${tinycolor(this.props.color)
                    .setAlpha(1)
                    .toString()};
              }
            }
            &:focus {
              color: ${tinycolor(this.props.color2)
                .lighten(10)
                .brighten(7.5)
                .toString()};
              text-decoration: underline;
              &:before {
                background: ${tinycolor(this.props.color2)
                  .lighten(10)
                  .brighten(7.5)
                  .toString()};
                box-shadow: 0 ${expandValue(sizes.space * 0.125)}
                  ${expandValue(sizes.space)}
                  ${tinycolor(this.props.color)
                    .setAlpha(1)
                    .toString()};
              }
            }
            &.active {
              text-shadow: 0 ${expandValue(sizes.space * 0.125)}
                ${expandValue(sizes.space * 0.5)}
                ${tinycolor(this.props.color2)
                  .setAlpha(0.4)
                  .toString()};
              color: ${tinycolor(this.props.color)
                .lighten(10)
                .brighten(7.5)
                .toString()};
              &:before {
                background: ${tinycolor(this.props.color)
                  .lighten(10)
                  .brighten(7.5)
                  .toString()};
              }
            }
          }
          .header strong {
            text-shadow: 0 ${expandValue(sizes.space * 0.125)}
              ${expandValue(sizes.space * 0.5)}
              ${tinycolor(this.props.color)
                .setAlpha(0.4)
                .toString()};
            color: ${tinycolor(this.props.color2)
              .lighten(10)
              .brighten(7.5)
              .toString()};
            &:hover {
              color: ${this.props.white};
            }
          }
          .top-floor {
            background: ${tinycolor(this.props.bg)
              .setAlpha(0.6)
              .darken(15)
              .toRgbString()};
            color: ${tinycolor(this.props.color2)
              .lighten(10)
              .brighten(7.5)
              .toString()};
            box-shadow: 0 ${expandValue(sizes.space * 0.125)}
              ${expandValue(sizes.space * 0.5)}
              ${tinycolor(this.props.color2)
                .setAlpha(0.3)
                .toString()};
            .st0 {
              stroke: ${tinycolor(this.props.color2)
                .lighten(10)
                .brighten(7.5)
                .toString()};
            }
            &:hover {
              box-shadow: 0 ${expandValue(sizes.space * 0.5)}
                ${expandValue(sizes.space)}
                ${tinycolor(this.props.color2)
                  .setAlpha(0.5)
                  .toString()};
              color: ${this.props.white};
              .st0 {
                stroke: ${this.props.white};
              }
            }
          }
          .LogoColor0 {
            flood-color: ${this.props.logoColor2};
          }
          .LogoColor1 {
            stop-color: ${this.props.logoColor1};
          }
          .LogoColor2 {
            stop-color: ${this.props.logoColor2};
          }
          .BgColor1 {
            stop-color: ${this.props.bg1};
          }
          .BgColor2 {
            stop-color: ${this.props.bg2};
          }
          .BgColor3 {
            stop-color: ${this.props.bg3};
          }
          .BgColor4 {
            stop-color: ${this.props.bg4};
          }
          .BgColor5 {
            stop-color: ${this.props.bg5};
          }
          .BgColor6 {
            stop-color: ${this.props.bg6};
          }
          .copyright {
            color: ${tinycolor(this.props.color2).toString()};
          }
          .copyright-link {
            color: ${tinycolor(this.props.color2)
              .lighten(10)
              .brighten(10)
              .toString()};
            &:hover {
              color: ${this.props.white};
            }
          }
        `}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Partials/ThemeColors.js